import { useState, useCallback, useEffect } from "react";
import { employeeTypeTaggingService } from "../services/employeeTypeTaggingService";
import { SetAuditTrail } from "../../components/Reports/AuditTrailReportEmployeeSetup";

export const useEmployeeTypeTagging = ({ showGeneralMessage, apiFilterPayload, user }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await employeeTypeTaggingService.getPreview(apiFilterPayload);
      setData(res.data || []);
      setOriginalData(res.data || []);
    } catch (err) {
      showGeneralMessage("Failed to load tagging history", false);
    } finally {
      setLoading(false);
    }
  }, [apiFilterPayload, showGeneralMessage]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSearch = (value) => {
    if (!value) return setData(originalData);
    const lower = value.toLowerCase();
    setData(originalData.filter(x => 
      x.employeeFullName.toLowerCase().includes(lower) || 
      x.transactionNumber.toLowerCase().includes(lower)
    ));
  };

  const createTagging = async (form) => {
    setLoading(true);
    try {
      const payload = {
        employeeId: form.employeeId,
        employeeTypeId: form.employeeTypeId,
        effectivityDate: form.effectivityDate,
        createdById: user?.id
      };

      const res = await employeeTypeTaggingService.create(payload);

      // Trigger Audit Trail
      await SetAuditTrail({
        Action: "Added Employee Type Tagging",
        Module: "Personnel",
        Reference: res.data.transactionNumber,
        Description: `Tagged ${form.employeeName} as ${form.employeeTypeDescription}`,
        UserId: user?.id
      });

      showGeneralMessage("Employee Type Tagging saved successfully!", true);
      fetchData();
      return true;
    } catch (err) {
      showGeneralMessage("Failed to save tagging", false);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { loading, data, handleSearch, createTagging, refresh: fetchData };
};